import { Injectable } from '@angular/core';

import { of } from 'rxjs';
import { tap, switchMap, map, catchError } from 'rxjs/operators';

import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import * as PrefsSearchResultsActions from '../actions/reports-prefs.actions';
import * as fromServices from '../../../scp/scp-common/services';
//import * as fromModels from '../../../scp/schools/models';
//import * as fromReducers from '../reducers';
import { ReportsSearchResultsState } from '..';

@Injectable()
export class ReportsPrefsSearchResultsEffects {
  constructor(
    private actions$: Actions,
    private PrefsService: fromServices.PrefsService,
  ) { }

  preferenceSet$ = createEffect(() => this.actions$.pipe(
    ofType(PrefsSearchResultsActions.PrefsSearchResultsActionTypes.LoadPrefsSearchResults),
    switchMap((action: PrefsSearchResultsActions.LoadPrefsSearchResults) => {
      console.log('Load Prefs Search Results Effect');
      console.log(action.payload);
        
      return this.PrefsService.loadPrefsBySchoolId(action.payload).pipe(
        tap(d => {
          console.log('searchPrefs returned:', d);
        }),
        map(resp => {

          return new PrefsSearchResultsActions.LoadPrefsSearchResultsSuccess(resp);
        }),
        catchError(error => of(new PrefsSearchResultsActions.LoadPrefsSearchResultsFailure(error)))
      );
    })
  ));
}
